// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"56162e82","297":"4ddb2b42","416":"e1c98f55","453":"38dbb8a3","624":"2c891260","678":"e6f7b014","818":"de352c5e","846":"32a59c3d","967":"3d30d2d4"}[chunkId] + ".chunk.js";
};